import { useEffect } from "react";

/**
 * Minimal head/meta injector — no react-helmet dependency.
 * Sets <title>, meta description, canonical, OG tags for a given page.
 */
export default function SEO({
  title,
  description,
  path = "",
  ogImage,
  noindex = false,
}) {
  useEffect(() => {
    if (title) document.title = title;
    const setMeta = (name, content, isProp = false) => {
      if (!content) return;
      const attr = isProp ? "property" : "name";
      let el = document.head.querySelector(`meta[${attr}="${name}"]`);
      if (!el) {
        el = document.createElement("meta");
        el.setAttribute(attr, name);
        document.head.appendChild(el);
      }
      el.setAttribute("content", content);
    };
    setMeta("description", description);
    setMeta("og:title", title, true);
    setMeta("og:description", description, true);
    setMeta("og:type", "website", true);
    if (ogImage) setMeta("og:image", ogImage, true);
    // Robots noindex — used for thank-you / private pages
    let robots = document.head.querySelector('meta[name="robots"]');
    if (noindex) {
      if (!robots) {
        robots = document.createElement("meta");
        robots.setAttribute("name", "robots");
        document.head.appendChild(robots);
      }
      robots.setAttribute("content", "noindex, nofollow");
    } else if (robots) {
      robots.remove();
    }
    // Canonical
    const origin = window.location.origin;
    let canonical = document.head.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement("link");
      canonical.setAttribute("rel", "canonical");
      document.head.appendChild(canonical);
    }
    canonical.setAttribute("href", `${origin}${path}`);
  }, [title, description, path, ogImage, noindex]);

  return null;
}
